import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Crop = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M19 22H11C10.45 22 10 21.55 10 21V5C10 4.45 9.55 4 9 4C8.45 4 8 4.45 8 5V8H5C4.45 8 4 8.45 4 9C4 9.55 4.45 10 5 10H8V21C8 22.65 9.35 24 11 24H19C19.55 24 20 23.55 20 23C20 22.45 19.55 22 19 22Z" />
		<path d="M27 22H24V11C24 9.35 22.65 8 21 8H13C12.45 8 12 8.45 12 9C12 9.55 12.45 10 13 10H21C21.55 10 22 10.45 22 11V27C22 27.55 22.45 28 23 28C23.55 28 24 27.55 24 27V24H27C27.55 24 28 23.55 28 23C28 22.45 27.55 22 27 22Z" />
	</svg>
);

export default Crop;
